import React from 'react';
import PurchaseReturnForm from './PurchaseReturnForm';
import { useParams } from 'react-router-dom';

const EditPurchaseReturnPage = () => {
    const { id } = useParams();
    
    // CHANGED: formType is now 'edit', enabling inputs in the form
    return id ? <PurchaseReturnForm formType="edit" currentId={id} /> : <div>Loading...</div>;
};

export default EditPurchaseReturnPage;